import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';

import { baseURL } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import PhoneOutlineIcon from 'mdi-react/PhoneOutlineIcon';
import Input from 'react-phone-number-input/input'

export class UserSearchDetails extends React.Component {

    constructor(props) {
        super(props)


        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            email: '',
            showError: false,
            isShowError: false,
        }
    }




    onSubmit(e) {
        e.preventDefault();


        let formData = {
            "msisdn": this.state.phone_number,
            "email": this.state.email

        }

        console.log("DATA", formData)
        this.setState({ isLoading: true });

        axios.post(baseURL + 'submit_contact', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            console.log("bayo", response.data)
            if (response.data.status) {

                this.setState({
                    statusMessage: "Success!",
                    phone_number: '',
                    email: '',
                    isShowError: true, isLoading: false, showError: false,

                });

            } else {

                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({
                showError: true,
                isShowError: false,
                statusMessage: error.response.data.message,
                submitted: true,
                isLoading: false
            });
        });


    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent } = this.state;

        return (
            <div className="pcoded-main-container">

                {showComponent && (
                    <div>

                        {this.state.showComponent ?
                            <peopleView /> : null
                        }

                    </div>
                )}

                {!hideComponent && (
                    <>

                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody><br />

                                    <div className="card__title">
                                        <h5 className="bold-text"></h5>
                                    </div>

                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}

                                    </div> : null}<br></br>

                                    {this.state.isShowError ? (
                                        <div
                                            color="success"
                                            style={{ fontSize: "13px", color: "green" }}>
                                            {this.state.statusMessage}
                                        </div>

                                    ) : null}<br></br>

                                    <form className="col-md-5 offset-md-4" onSubmit={this.onSubmit}>
                                        <br />
                                        <div className="col-md-10-offset-1">
                                            <div className="form-group">
                                                <div className="col-md-12">
                                                    <label className="form-label">Email Address</label>
                                                </div>
                                                <div className="col-md-12">
                                                    <input id="input" type="text" required className="form-control"
                                                        name="email" placeholder='Enter Your Email '
                                                        value={this.state.email}
                                                        onChange={e => this.setState({ email: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="form-group">
                                            <label className="form-label">Phone Number</label>
                                            <div className="form__form-group-field">
                                                <div className="form__form-group-icon">
                                                    <PhoneOutlineIcon />
                                                </div>
                                                <Input
                                                    country="KE"
                                                    international
                                                    withCountryCallingCode
                                                    className="form-control"
                                                    placeholder="Ваш телефон"
                                                    name="phone_number"
                                                    id="input"
                                                    value={this.state.phone_number}
                                                    onChange={value => this.setState({ phone_number: value })} />
                                            </div>

                                        </div>
                                        <div className="col-md-4 offset-md-4">
                                            <br /><br /><br />
                                            <Button type="submit" outline color="primary" className="btn-paypal btn-lg pull-center" >
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}  <i className="fa fa-"></i></Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
